"use client";

import {AnimatePresence, motion} from "framer-motion";
import Image from "next/image";
import {TINY_BLUR_DATA_URL} from "@/lib/image-blur";

type DynamicLogoProps = {
  locale: "en" | "hi";
  alt?: string;
  className?: string;
  priority?: boolean;
};

export function DynamicLogo({locale, alt, className, priority}: DynamicLogoProps) {
  const source = locale === "hi" ? "/images/logo-hi.png" : "/images/logo-en.png";
  const resolvedAlt =
    alt ?? (locale === "hi" ? "ब्लूमिंग डेंटल क्लिनिक — बस्ती में दंत चिकित्सालय" : "Blooming Dental Clinic — dentist in Basti");

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={locale}
        initial={{opacity: 0, y: 6}}
        animate={{opacity: 1, y: 0}}
        exit={{opacity: 0, y: -6}}
        transition={{duration: 0.24, ease: "easeOut"}}
        className="rounded-xl bg-transparent"
      >
        <Image
          src={source}
          alt={resolvedAlt}
          width={220}
          height={72}
          sizes="(max-width: 640px) 200px, 220px"
          className={`${className ?? ""} h-auto max-h-36 w-auto bg-transparent`}
          priority={priority}
          placeholder="blur"
          blurDataURL={TINY_BLUR_DATA_URL}
          suppressHydrationWarning
        />
      </motion.div>
    </AnimatePresence>
  );
}
